module.exports = __webpack_public_path__ + "img/t3-endorsement-statement.70a3f607.png";